import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import lscache from "lscache";

import axios from "@app/lib/axios";
import * as util from "@app/lib/utility";
import * as commonData from "@app/lib/common_data";

import * as Constant from "../../Constant.js";
import Header from "../../components/Header";
import Side from "./Side.js";
import * as MenuComponent from "../../Components.js";

const Nav = ({ type, userId, logoutHandeler }) => {
    const [menuList, setMenuList] = useState([]);
    const [routes, setRoutes] = useState([]);
    const urlBase = process.env.REACT_APP_BASE_URL;
    const getMenuPath = (path) => {
        return path && path.indexOf("http") == 0 ? path : path;
    };
    const arrangeMenu = (list) => {
        const routeArr = [];
        const menus = [];
        let isFirstMenu = true;
        list.forEach((menu) => {
            if (menu.menu_read) {
                if (menu.path && menu.component_name) {
                    routeArr.push({
                        id: menu.id,
                        component: MenuComponent[menu.component_name],
                        path: menu.path,
                        path_exact: menu.path_exact,
                    });
                    if (isFirstMenu && menu.is_root_menu > 0) {
                        isFirstMenu = false;
                        routeArr.push({
                            id: "home_" + menu.id,
                            component: MenuComponent[menu.component_name],
                            path: "/",
                            path_exact: 1,
                        });
                    }
                }

                var c = menus.find((m) => m.c_id == menu.category_id);
                if (!c) {
                    c = { c_id: menu.category_id, c_name: menu.category_name, menu: [] };
                    menus.push(c);
                }
                const menuList = c.menu;

                if (menu.depth === 0) {
                    menuList.push({
                        id: menu.id,
                        name: menu.name,
                        icon: menu.icon,
                        component: menu.component_name,
                        read: menu.menu_read,
                        write: menu.menu_write,
                        path: getMenuPath(menu.path),
                        path_exact: menu.path_exact,
                        display_order: menu.display_order,
                        is_nav: menu.is_nav,
                        modules: [],
                        child: [],
                    });
                    c.menu = menuList;
                } else if (menu.depth === 1) {
                    menuList.forEach((parent_menu) => {
                        if (menu.group_id === parent_menu.id) {
                            if (menu.is_module == 1) {
                                parent_menu.modules.push({
                                    id: menu.id,
                                    name: menu.name,
                                    icon: menu.icon,
                                    component: menu.component_name,
                                    read: menu.menu_read,
                                    write: menu.menu_write,
                                    path: getMenuPath(menu.path),
                                    path_exact: menu.path_exact,
                                    display_order: menu.display_order,
                                });
                            } else {
                                parent_menu.child.push({
                                    id: menu.id,
                                    name: menu.name,
                                    icon: menu.icon,
                                    component: menu.component_name,
                                    read: menu.menu_read,
                                    write: menu.menu_write,
                                    path: getMenuPath(menu.path),
                                    path_exact: menu.path_exact,
                                    display_order: menu.display_order,
                                    is_nav: menu.is_nav,
                                    modules: [],
                                    child: [],
                                });
                            }
                        }
                    });
                } else if (menu.depth === 2) {
                    menuList.forEach((parent_menu) => {
                        parent_menu.child.forEach((child) => {
                            if (child.id === menu.group_id) {
                                if (menu.is_module == 1) {
                                    child.modules.push({
                                        id: menu.id,
                                        name: menu.name,
                                        icon: menu.icon,
                                        component: menu.component_name,
                                        read: menu.menu_read,
                                        write: menu.menu_write,
                                        path: getMenuPath(menu.path),
                                        path_exact: menu.path_exact,
                                        display_order: menu.display_order,
                                    });
                                } else {
                                    child.child.push({
                                        id: menu.id,
                                        name: menu.name,
                                        icon: menu.icon,
                                        component: menu.component_name,
                                        read: menu.menu_read,
                                        write: menu.menu_write,
                                        path: getMenuPath(menu.path),
                                        path_exact: menu.path_exact,
                                        display_order: menu.display_order,
                                        is_nav: menu.is_nav,
                                    });
                                }
                            }
                        });
                    });
                }
            }
        });
        setRoutes(routeArr);
        setMenuList(menus);
    };
    useEffect(() => {
        const cacheKey = commonData.getCacheKey(Constant.LSCACHE_KEY.MENUS);
        const cached = lscache.get(cacheKey);
        if (!cached) {
            axios({
                method: "get",
                url: `${Constant.API_DOMAIN}/api/user/menu/${type}/${userId}`,
            })
                .then((result) => {
                    const list = result.data.list;
                    lscache.set(cacheKey, list, Constant.LSCACHE_BASE_EXPIRE_MINUTE);
                    arrangeMenu(list);
                })
                .catch((error) => {
                    console.log(error);
                    console.error("알 수 없는 오류가 발생하였습니다. \n지속 발생시 관리자에게 문의해주세요.");
                    setMenuList([]);
                    lscache.remove(cacheKey);
                });
        } else {
            arrangeMenu(cached);
        }
        return () => {};
    }, [type, userId]);

    return (
        <Router exact path={urlBase} basename={urlBase}>
            {util.isFullPage() ? null : (
                <>
                    <Header menuList={menuList} logoutHandeler={logoutHandeler} />
                    <Side menuList={menuList} />
                </>
            )}
            <Switch>
                {routes.map((r, index) => {
                    return <Route exact={r.path_exact === 1} path={r.path} component={r.component} key={r.id + "_Route" + index} />;
                })}
            </Switch>
        </Router>
    );
};

export default Nav;
